module.exports = __webpack_public_path__ + "img/emoticon-happy-outline.db92ee0a.svg";